import { BaseEnum } from './BaseEnum';

export const PortalTypes = {
    None: 0,
    Sso: 1,
    Provider: 2,
    Admin: 3,
    Coordinator: 4,
    Reports: 5,
    Patient: 6,

    getPortalType: function () {
        const portal = window.environment.PORTAL_NAME;
        switch (portal) {
            case 'sso':
                return 1;
            case 'provider':
                return 2;
            case 'admin':
                return 3;
            case 'coordinator':
                return 4;
            case 'reports':
                return 5;
            case 'patient':
                return 6;
            default:
                return 0;
        }
    },

    getFeatureKey: function (portal) {
        switch (portal) {
            case 'provider':
                return 'providerPortal';
            case 'admin':
                return 'adminPortal';
            case 'coordinator':
                return 'coordinatorPortal';
            case 'reports':
                return 'reportsPortal';
            case 'patient':
                return 'patientPortal';
            default:
                return false;
        }
    },

    ...BaseEnum,
};
